import React, { Component } from "react";
import { profile, GET, PUT, alert } from "./CustomComponent.js";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import "../assets/css/bootstrap.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: "",
      array_link: [
        { name: "Dashboard", icon: "\uf62a", link: "/dashboard" },
        { title: "ข้อมูลผู้ใช้" },
        { name: "ชาวไร่", icon: "\uf007", link: "/farmer" },
        { name: "พนักงาน", icon: "\uf508", link: "/admin" },
        { title: "รายงาน" },
        { name: "แผนที่", icon: "\uf5a0", link: "/map" },
        { name: "รายงานแปลง", icon: "\uf659", link: "/report" },
        { title: "การตั้งค่า" },
        { name: "ประเภทอ้อย", icon: "\uf6bd", link: "/setting/cane_type" },
        { name: "พันธุ์อ้อย", icon: "\uf06c", link: "/setting/cane_varieties" },
        { name: "สูตรปุ๋ย", icon: "\uf4d8", link: "/setting/fertilizer_formula" },
        { name: "ยี่ห้อปุ๋ย", icon: "\uf81c", link: "/setting/fertilizer_brand" },
        { name: "ประเภทกิจกรรมที่ดิน", icon: "\uf70c", link: "/setting/activity_type_land" },
        { name: "ประเภทกิจกรรมอ้อย", icon: "\uf70c", link: "/setting/activity_type_cane" },
        { name: "สถานะแปลง", icon: "\uf0db", link: "/setting/plot_status" },
        { name: "ปีการผลิต", icon: "\uf073", link: "/setting/production_year" },
        { name: "รถตัดอ้อย", icon: "\uf47a", link: "/setting/cane_cutter" },
        { name: "สถานะครอบครอง", icon: "\uf02d", link: "/setting/ownership_status" },
        { name: "เอกสารสิทธิ์", icon: "\uf15b", link: "/setting/document_rights" },
        { name: "สถานะเตรียมแปลง", icon: "\uf02e", link: "/setting/plot_preparation_status" },
        { name: "ประเภทการพ่นยา", icon: "\uf485", link: "/setting/spraying_type" },
        { name: "ประเภทการตัด", icon: "\uf0c4", link: "/setting/cutting_type" },
        { name: "ประเภทปุ๋ยน้ำ", icon: "\uf043", link: "/setting/liquid_fertilizer_type" },
        { name: "ประเภทดิน", icon: "\uf57d", link: "/setting/soil_type" },
        { name: "รถบรรทุก", icon: "\uf0d1", link: "/setting/truck" },
        { name: "คนขับรถบรรทุก", icon: "\uf007", link: "/setting/truck_driver" },
      ],
      user_profile: profile
    };
  }
  icon = (io) => {
    return <span className="icon">{io}</span>;
  };
  componentDidMount() {
    this.Get();
  }
  compomentDidUpdate() {
      const active = document.getElementsByClassName("active");
      if (active.length > 0) {
        active[0].focus();
        active[0].scrollIntoView({ behavior: "smooth", block: "center" });
      }
  }
  Get = async () => {
      let result = await GET("admin/manage/users/profile");
      if (result?.status) {
        console.log("GET:",result.data);
        localStorage.setItem("scp-profile", JSON.stringify(result.data));
        this.setState({user_profile: result.data});
      }
    };
  render() {
    const { dropdown, array_link } = this.state;
    return (
      <div className="hpx-50">
        <Navbar className="px-3 px-xl-5 bg-light position-fixed w-100" style={{ zIndex: 1000 }} expand="xl">
          <Navbar.Brand href="/dashboard" className="fw-bold text-primary">
            SmartCanePro
          </Navbar.Brand>
          <Navbar.Toggle className="border-0" aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="overflow-auto">
            <Nav className="ms-auto">
              <div className="d-none d-xl-flex align-items-center px-3">
                <span className="icon text-primary me-1">{"\uf007"}</span>
                <div className="px-2">
                  <div className="text-14">
                    {profile?.full_name || "ชื่อผู้ใช้"} 
                  </div>
                  <div className="text-12" style={{ marginTop: -2 }}>
                    {profile?.user_type}
                  </div>
                </div>
              </div>
              <div className="d-block d-xl-none mb-5" style={{ height: "80vh" }}>
                {array_link.map((item, index) => (
                  <>
                    {item.title ? (
                      <div className="mb-3">
                        <b>{item.title}</b>
                      </div>
                    ) : (
                      <a href={item.link} className={`btn btn-outline-primary border-0 rounded-4 w-100 text-start d-flex align-items-center justify-content-start p-1 mb-2 ${item.link === window.location.pathname ? "active" : ""}`}>
                        <span className="icon wpx-40 hpx-40 rounded-4 bg-white me-2 d-flex align-items-center justify-content-center">{item.icon}</span>
                        {item.name}
                      </a>
                    )}
                  </>
                ))}
                <button
                  className="btn btn-outline-primary border-0 rounded-4 w-100 text-start d-flex align-items-center justify-content-start p-1 mb-2 text-danger"
                  onClick={async () => {
                    if (await alert("", "warning", "ยืนยัน", "ยืนยันการออกจากระบบหรือไม่่?", "ออกจากระบบ", "ยกเลิก")) {
                      localStorage.clear();
                      window.location.href = "/";
                    }
                  }}
                >
                  <span className="icon wpx-40 hpx-40 rounded-4 bg-white me-2 d-flex align-items-center justify-content-center">{"\uf2f5"}</span>
                  ออกจากระบบ
                </button>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div className="position-fixed wpx-260 bg-light px-3 overflow-scroll d-none d-xl-block" style={{ zIndex: 1, padding: 60, height: "100vh" }}>
          {array_link.map((item, index) => (
            <>
              {item.title ? (
                <div className="mb-3">
                  <b>{item.title}</b>
                </div>
              ) : (
                <a href={item.link} className={`btn btn-outline-primary border-0 rounded-4 w-100 text-start d-flex align-items-center justify-content-start p-1 mb-2 ${item.link === window.location.pathname ? "active" : ""}`}>
                  <span className="icon wpx-40 hpx-40 rounded-4 bg-white me-2 d-flex align-items-center justify-content-center">{item.icon}</span>
                  {item.name}
                </a>
              )}
            </>
          ))}
          <button
            className="btn btn-outline-primary border-0 rounded-4 w-100 text-start d-flex align-items-center justify-content-start p-1 mb-2 text-danger"
            onClick={async () => {
              if (await alert("", "warning", "ยืนยัน", "ยืนยันการออกจากระบบหรือไม่่?", "ออกจากระบบ", "ยกเลิก")) {
                localStorage.clear();
                window.location.href = "/";
              }
            }}
          >
            <span className="icon wpx-40 hpx-40 rounded-4 bg-white me-2 d-flex align-items-center justify-content-center">{"\uf2f5"}</span>
            ออกจากระบบ
          </button>
        </div>
      </div>
    );
  }
}
